import { createRouter, createWebHistory, isNavigationFailure } from 'vue-router'
import { nextTick } from 'vue'
import { getToken } from '@/utils/auth'
import { loginPath, homePath } from './routerNames'
import { scrollBehavior } from './scrollBehavior'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import AuthRouter from './AuthRouter'
import StepRouter from './StepRouter'
import ManagerRouter from './ManagerRouter'
import SettingRouter from './SettingRouter'
import i18n from '@/plugins/i18n'
import { formatTitleWithEnvironment } from '@/utils/environment'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ManagerRouter,
    SettingRouter,
    StepRouter,
    AuthRouter,
    {
      path: '/:pathMatch(.*)*',
      component: () => import('../views/NotFoundView.vue')
    }
  ],
  scrollBehavior
})

// Global Guards
router.beforeEach(
  (to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const token = getToken()

    if (token) {
      to.meta.redirectIfToken ? next(homePath) : next()
    } else {
      if (to.meta.requiresAuth && to.path !== loginPath) {
        sessionStorage.setItem('redirectPath', to.fullPath)
        next(loginPath)
      } else {
        next()
      }
    }
  }
)

// Global After Hooks
router.afterEach((to, _from, failure) => {
  if (isNavigationFailure(failure)) return
  const { t } = i18n.global
  nextTick(() => {
    if (typeof to.meta.title === 'string') {
      const baseTitle = `${t(to.meta.title)} - PersGPTマイページ`
      document.title = formatTitleWithEnvironment(baseTitle)
    }
  })
})

export default router
